//Site/app base URI
export const netlifyURI = 'https://app.vxmed.org/';

export default netlifyURI;
